import { DateTime } from "luxon";

// avoid cases like 2009 being a valid date
export const isValidDate = (value: string) => DateTime.fromISO(value).isValid && !Number(value);
